(function ($) {
    'use strict';
    /**
     * плагин масштабирвоания текста
     * */
    $.fn.simpleTabsWithHover = function () {
        var $self = $(this);
        var $headerItems = $self.find('.js-simple-tabs-with-hover-header');
        var $contentItems = $self.find('.js-simple-tabs-with-hover-content');
        var ACTIVE_CLASS = 'active';

        var firstInit = function () {
            toggleActiveClass(0);
        };

        var removeActiveClass = function () {
            $headerItems.removeClass(ACTIVE_CLASS);
            $contentItems.removeClass(ACTIVE_CLASS);
        };

        var hangHandler = function () {
            $headerItems.each(function (index) {
                $(this).on('click', function () {
                    toggleActiveClass(index);
                });

                $(this).on('mouseenter', function () {
                    toggleActiveClass(index);
                });
            });
        };

        var toggleActiveClass = function (index) {
            removeActiveClass();
            $headerItems.eq(index).addClass(ACTIVE_CLASS);
            $contentItems.eq(index).addClass(ACTIVE_CLASS);
        };


        var init = function () {
            firstInit();
            hangHandler();
        };

        init();
        return this;
    };
    $('.js-simple-tabs-with-hover').each(function () {
        $(this).data('simpleTabsWithHover', $(this).simpleTabsWithHover());
    });
})(jQuery);
